export interface CreateQuarantinedPartFromNonConformanceReportDto {
	nonConformanceReportId: number;
	numberOfPartsAffected: number;
	workOrderId: number;
}

export class CreateQuarantinedPartFromNonConformanceReportDto implements CreateQuarantinedPartFromNonConformanceReportDto {	
	constructor(data?: Partial<CreateQuarantinedPartFromNonConformanceReportDto>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}